const doc = [({"zh_tw":({"constantPayType":({"on_site":"現場付款", "pre_payment":"預付款"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;